<script>
import pageHeader from '../layoutComponents/page-header.vue'
import AdminActivityHistory from '@/components/common/historyActivity/AdminHistoryActivity'
import UserActivityHistory from '@/components/common/historyActivity/UserHistoryActivity'
import WorkFlowHistoryActivity from '@/components/common/historyActivity/WorkFlowHistoryActivity'
import Editable from '@/components/common/form/type/Editable'
import ReadOnly from '@/components/common/form/type/ReadOnly'
import Table from '@/components/common/form/type/Table'
import StatusBar from '@/components/teamtask/StatusBar'
import Feedback from '@/components/common/form/type/Feedback'
import CheckDocuments from '@/components/common/form/type/CheckDocuments'
import ProductInformation from '@/components/common/form/type/ProductInformation'
import Comment from '@/components/comment/Comment'
import TeamTaskDataprovider from '../../services/teamtask'
import { teamTaskMixins, userHistoryMixins } from '../../utils/mixins'
import TeamTaskAssignee from '../../services/teamTaskAssignee'
import Button from '../common/Button.vue'
import UserHistoryDataProvider from '../../services/userHistory'
import ComboBox from '../common/form/formModules/ComboBox.vue'
import Messages from '../messages/Messages.vue'

export default {
  mixins: [teamTaskMixins, userHistoryMixins],
  data() {
    return {
      rejectModal: false,
      selectedRejectID: null,
      messagesList: [
        {
          id: 1,
          title: '',
          message: 'کاربر گرامی اطلاعات وارد شده با مشخصات مالک سیمکارت مطابقت ندارد.',
        },
        {
          id: 2,
          title: '',
          message: 'کاربر گرامی اطلاعات وارد شده با کارت ملی مطابقت ندارد.',
        },
        {
          id: 3,
          title: '',
          message: 'کاربر گرامی اطلاعات وارد شده صحیح نمی باشد.',
        },
        {
          id: 4,
          title: '',
          message: 'کاربر گرامی نام و نام خانوادگی باید کامل وارد شود.',
        },
        {
          id: 5,
          title: '',
          message: 'کاربر گرامی استفاده از نام مستعار مجاز نمی باشد.',
        },
        {
          id: 6,
          title: '',
          message: 'کاربر گرامی تصویر کارت ملی شما به دلیل عدم تطابق مشخصات کارت ملی با مالک سیمکارت مورد تایید قرار نگرفت.',
        },
        {
          id: 7,
          title: '',
          message: 'کاربر گرامی تصویر کارت ملی شما به دلیل ناخوانا بودن مورد تایید قرار نگرفت.',
        },
        {
          id: 8,
          title: '',
          message: 'کاربر گرامی تصویر کارت ملی شما به دلیل عدم وضوح کافی مورد تایید قرار نگرفت.',
        },
        {
          id: 9,
          title: '',
          message: 'کاربر گرامی تصویر کارت ملی شما به دلیل عدم رعایت شرایط ارسال کارت ملی مورد تایید قرار نگرفت.',
        },
        {
          id: 10,
          title: '',
          message: 'کاربر گرامی تصویر کارت ملی از روی کپی یا کپی برابر اصل مورد قبول نمی باشد.',
        },
        {
          id: 11,
          title: '',
          message: 'کاربر گرامی تصویر کارت ملی از روی فایل مورد قبول نمی باشد.',
        },
        {
          id: 12,
          title: '',
          message: 'کاربر گرامی ویدئوی شما به دلیل عدم رعایت حجاب مناسب مورد تایید قرار نگرفت.',
        },
        {
          id: 13,
          title: '',
          message: 'کاربر گرامی ویدئوی شما به دلیل استفاده از کلاه یا عینک مورد تایید قرار نگرفت.',
        },
        {
          id: 14,
          title: '',
          message: 'کاربر گرامی ویدئوی شما به دلیل عدم وضوح صدا مورد تایید قرار نگرفت.',
        },
        {
          id: 15,
          title: '',
          message: 'کاربر گرامی ویدئوی شما به دلیل عدم وضوح تصویر مورد تایید قرار نگرفت.',
        },
        {
          id: 16,
          title: '',
          message: 'کاربر گرامی ویدئوی شما به دلیل عدم تطابق با تصویر کارت ملی مورد تایید قرار نگرفت.',
        },
        {
          id: 17,
          title: '',
          message: 'کاربر گرامی ویدئوی شما به دلیل استفاده از گریم یا آرایش غلیظ مورد تایید قرار نگرفت.',
        },
        {
          id: 18,
          title: '',
          message: 'کاربر گرامی ویدئوی شما به دلیل عدم رعایت شرایط ضبط ویدئو مورد تایید قرار نگرفت.',
        },
      ],
      forceUpdateComponent: 1,
      items: [
        {
          text: 'داشبورد',
          href: '/',
        },
        {
          text: 'جزییات تیم تسک',
          active: true,
        },
      ],
      query: null,
      pageData: [],
      transitions: [],
      mainData: {},
      assigneModal: null,
      searchedAssignee: '',
      opratorList: [],
      showResult: false,
      isEmpty: false,
      WorkFlowHistoryActivityKey: 1,
      selectOprator: '',
      assigneeFullData: null,
      operatorPagination: {
        keyword: '',
        pageNumber: 1,
        pageSize: 10,
      },
      operatorPaginationData: null,
      messageModalLoading: false,
      messageModalKey: 25,
      // updateWorkFlowHistory: null,
    }
  },
  components: {
    pageHeader,
    StatusBar,
    AdminActivityHistory,
    UserActivityHistory,
    WorkFlowHistoryActivity,
    Editable,
    Table,
    ProductInformation,
    Comment,
    ReadOnly,
    CheckDocuments,
    Feedback,
    Button,
    ComboBox,
    Messages,
  },
  mounted() {
    if (this.$route.query.navLink) {
      this.query = this.$route.query.navLink
    } else {
      this.query = this.$route.params.id
    }
    TeamTaskDataprovider.getTeamTaskDetails({
      key: this.query,
      boardId: this.$route.params.slug !== 'detail' && this.$route.name !== 'UserInformation' ? this.$route.params.slug : 'Ordering-2' ,
    })
      .then((res) => {
        this.mainData = res.data.data
        this.pageData = res.data.data.components
        this.transitions = res.data.data.transitions
        for (let i = 0; i < this.pageData.length; i++) {
          this.pageData[i].id = this.pageData[i].id.toString()
        }
        let assigne = {
          color: res.data.data.assignee.color,
          value: res.data.data.assignee.fullName,
          icon: res.data.data.assignee.icon,
          key: res.data.data.assignee.id,
        }
        this.$store.dispatch('teamTask/setTeamtaskDetail', res.data.data)
        this.setTeamTaskAssignee(assigne)
      })
      .catch((err) => {})
    this.getOprators(this.operatorPagination, 1)
  },
  methods: {
    searchedOprator(search) {
      this.operatorPagination.pageNumber = 1
      this.operatorPagination.keyword = search
      this.getOprators(this.operatorPagination, 1)
    },
    loadMoreOprator() {
      if (this.opratorList.length < this.operatorPaginationData.totalCount) {
        this.operatorPagination.pageNumber += 1
        this.getOprators(this.operatorPagination, 2)
      } else {
        return
      }
    },
    getOprators(payload, type) {
      TeamTaskAssignee.getOprators(payload).then((res) => {
        if (type === 1) {
          this.opratorList = res.data.data.people
        } else if (type === 2) {
          this.opratorList.push(...res.data.data.people)
        }
        this.operatorPaginationData = res.data.pagination
      })
    },
    findData(arr, type) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].type === type) {
          return arr[i]
        }
      }
    },
    changeStatus(payload) {
      if (payload.isNeedSendMessage) {
        this.rejectModal = true
        this.selectedRejectID = payload.id
      } else {
        TeamTaskDataprovider.changeTaskStatus({
          key: this.$route.params.id,
          statusId: payload.id,
        }).then((res) => {
          this.updateStatus()
          this.rejectModal = false
        })
      }
    },
    closeMessageModal() {
      this.rejectModal = false
      this.messageModalLoading = false
      this.messageModalKey += 1
    },
    selectedMessage(payload) {
      this.messageModalLoading = true
      TeamTaskDataprovider.changeTaskStatus({
        key: this.$route.params.id,
        statusId: this.selectedRejectID,
        message: payload,
      }).then((res) => {
        this.updateStatus(true)
      })
    },
    addedMessage(payload) {
      this.messageModalLoading = true
      TeamTaskDataprovider.changeTaskStatus({
        key: this.$route.params.id,
        statusId: this.selectedRejectID,
        message: payload.customTextMessage,
      }).then((res) => {
        this.updateStatus(true)
      })
    },
    updateStatus(payload) {
      TeamTaskDataprovider.getTeamTaskDetails({
        boardId: this.$route.params.slug,
        key: this.query,
      })
        .then((res) => {
          this.mainData = res.data.data
          this.pageData = res.data.data.components
          this.transitions = res.data.data.transitions
          for (let i = 0; i < this.pageData.length; i++) {
            this.pageData[i].id = this.pageData[i].id.toString()
            if (payload && i == this.pageData.length - 1) {
              this.closeMessageModal()
            }
          }
          this.$store.dispatch('teamTask/setTeamtaskDetail', res.data.data)
          this.forceUpdateComponent += 1
        })
        .catch((err) => {})
    },
    searchOprator() {
      this.showResult = true
      TeamTaskAssignee.getOprators({ search: this.$refs.assigneeInput.value }).then((res) => {
        if (res.data.length !== 0) {
          this.isEmpty = false
          this.opratorList = res.data.data.people
        } else {
          this.isEmpty = true
        }
      })
    },
    selectedOprator(oprator) {
      this.assigneeFullData = oprator
      this.selectOprator = oprator.value
      this.showResult = false
    },
    emptyDefaultValues(baseData) {
      if (baseData.type == 'Editable')
        if (!baseData.defaultValues) {
          return false
        } else {
          return true
        }
      else {
        return true
      }
    },
    openModal() {
      this.assigneModal = true
      this.selectOprator = this.assignee.value
    },
    assign() {
      TeamTaskAssignee.assignOprator({
        key: this.$route.params.id,
        userId: this.assigneeFullData.key,
        fullName: this.selectOprator,
      })
        .then((res) => {
          this.assigneModal = false
          this.setTeamTaskAssignee(this.assigneeFullData)
        })
        .catch((err) => {})
    },
    getWorkflowHistory(data) {
      UserHistoryDataProvider.getUserHistory(data)
        .then((res) => {
          this.setWorkFlowHistoryData(res.data.data.message.historyDto)
          this.WorkFlowHistoryActivityKey += 1
        })
        .catch((err) => {})
    },
    updateWorkFlowHistory() {
      this.getWorkflowHistory({ IssueKey: this.$route.params.id })
    },
  },
}
</script>

<template>
  <div>
    <div class="headere sticky-top">
      <pageHeader :title="`جزییات درخواست ${mainData.customer.fullName}`" :items="items" class="team-task-detail-header" />
      <StatusBar @updateStatus="changeStatus($event)" :transitions="transitions" class="team-task-detail-status-bar" />
    </div>
    <div class="row main-row-mt">
      <div class="col-8" style="padding-right: 0 !important">
        <div v-for="baseData in pageData" :key="baseData.id">
          <div class="detailsSection mb-3" v-if="emptyDefaultValues(baseData)">
            <component :key="forceUpdateComponent" :is="baseData.type" :componentData="baseData" :mainData="mainData" />
          </div>
        </div>
      </div>
      <div class="col-4" style="padding-left: 0 !important">
        <AdminActivityHistory @updatePriority="updateWorkFlowHistory" />
        <div class="mt-3">
          <UserActivityHistory @showAssigneModal="openModal" />
        </div>
        <div class="mt-3">
          <WorkFlowHistoryActivity :needUpdate="updateWorkFlowHistory" :key="WorkFlowHistoryActivityKey" />
        </div>
        <div class="mt-3">
          <Comment :totalPages="commentTotalPages" @updateWorkFlowHistory="updateWorkFlowHistory" />
        </div>
      </div>
      <b-modal v-model="rejectModal" body-class="teamtaskDetailModalBodyClass" hide-footer centered title="ثبت دلیل رد شدن">
        <div>
          <Messages
            :messages="messagesList"
            @closeModal="modalVisible = $event"
            @selectedMessageText="selectedMessage($event)"
            @typedCustomMessage="addedMessage($event)"
            :selectLoading="messageModalLoading"
            :key="messageModalKey"
          />
        </div>
      </b-modal>
      <b-modal @hide="showResult = false" v-model="assigneModal" body-class="teamtaskDetailModalBodyClass" hide-footer centered title="واگذاری به">
        <div class="custom-content">
          <!-- <p class="modal-text">واگذاری تسک</p>
          <input class="change-assignee-input" :placeholder="assignee.fullName" ref="assigneeInput" @keyup="searchOprator" />
          <div v-if="showResult" class="oprator-list">
            <div v-if="!isEmpty">
              <div v-for="oprator in opratorList" :key="oprator.id" class="operator-item">
                <div class="oprator" @click="selectOprator(oprator)">
                  <div>{{ oprator.fullName }}</div>
                </div>
              </div>
            </div>
            <div v-else>کاربری یافت نشد</div>
          </div> -->
          <ComboBox
            @loadMoreData="loadMoreOprator"
            @searchedItem="searchedOprator"
            :searchedData="opratorList"
            @selectedItem="selectedOprator"
            :selectedValue="selectOprator"
            pagination
            placeholder="انتخاب کنید"
            title="اپراتور"
          />
          <div class="button-wrapper">
            <div @click="assigneModal = false" class="me-2"><Button text="انصراف" btnClass="cancel btn-border" /></div>
            <div @click="assign"><Button text="انتقال" btnClass="aprove btn-border" /></div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '../../design/custom/components/_change_assigne_modal.scss';
::v-deep .modal-dialog {
  max-width: 540px !important;
}
::v-deep .modal-backdrop {
  background-color: rgba(19, 19, 19, 0.9) !important;
}
.detailsSection {
  background: #ffffff;
  border-radius: 8px;
  border: none;
  height: auto;
  padding: 16px;
}
.title {
  font-style: normal;
  margin-bottom: 10px;
  font-weight: normal;
  font-size: 16px;
  line-height: 26px;
  text-align: right;
  text-transform: uppercase;
  color: #444444;
}
.description {
  margin-bottom: 30px;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 25px;
  text-align: right;
  color: #999999;
}
.headere {
  width: 100%;
  height: 80px;
  z-index: 2 !important;
}
.team-task-detail-header {
  width: 100%;
  position: sticky;
  top: 60px;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f8f8fb;
}
::-webkit-scrollbar {
  // width: 5px;
  display: none;
}
// ::-webkit-scrollbar-track {
//   box-shadow: inset 0 0 5px grey;
//   border-radius: 10px;
// }
// ::-webkit-scrollbar-thumb {
//   border-radius: 5px;
//   background: #556ee6;
// }
.title {
  font-style: normal;
  margin-bottom: 10px;
  font-weight: normal;
  font-size: 16px;
  line-height: 26px;
  text-align: right;
  text-transform: uppercase;
  color: #444444;
}
.button-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;
}
.cancel {
  background-color: rgba(51, 51, 51, 0.6) !important;
}
.btn-border {
  border-radius: 4px !important;
}
.aprove {
  background-color: #556ee6 !important;
  width: 119px !important;
}
.description {
  margin-bottom: 30px;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 25px;
  text-align: right;
  color: #999999;
}
.custom-content {
  z-index: 30 !important;
}

.oprator-list {
  height: 242px;
  overflow-x: hidden;
  overflow-y: scroll;
  border: 2px solid #ffffff;
  box-shadow: 0px 0px 6px 0px #5d4e7b1a inset;
}

.oprator {
  cursor: pointer;
  color: #808080;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 25px;
  letter-spacing: 0em;
  padding: 6px;
  z-index: 100 !important;
}
.operator-item {
  transition: 0.2s ease-in-out;
}
.operator-item:hover {
  background-color: #f8f9fa;
}
.team-task-detail-status-bar {
  position: sticky;
  top: 80px;
  z-index: 4;
}
.main-row-mt {
  height: calc(100vh - 220px);
  overflow-y: auto;
  overflow-x: hidden !important;
  margin: 35px 0 0 0;
  padding: 0 0 20px 0;
}
</style>
